import { scrollPreset } from './scroll-preset';
export function cretateHooks(options) {
    if (!options) {
        return scrollPreset;
    }
    var hooks = {};
    if (options.preset) {
        Object.assign(hooks, options.preset);
    }
    else {
        Object.assign(hooks, scrollPreset);
    }
    Object.keys(options)
        .filter(function (key) { return key !== 'preset'; })
        .forEach(function (key) {
        hooks[key] = options[key];
    });
    return hooks;
}
//# sourceMappingURL=hooks-factory.js.map